import { HelpRounded } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import EyeBrow, { IStyledEyeBrowProps } from 'component/MarketPlace/eyeBrow/eyeBrow';
import React from 'react';
import { useProductEyebrow } from '../hooks/useProductEyebrow';

type ProductEyebrowProps = Partial<IStyledEyeBrowProps> & {
  text: string;
  reason?: string;
  locale?: Record<string, string>;
};

const ProductEyebrow = (props: ProductEyebrowProps) => {
  const { text, reason = '', locale, sx, ...rest } = props;
  const eyebrow = useProductEyebrow(text, locale);

  if (!eyebrow.text) return null;

  return (
    <EyeBrow
      label={eyebrow.text}
      variant="filled"
      size="small"
      endIcon={
        <Tooltip title={reason} arrow placement="top">
          <HelpRounded sx={{ margin: '0 !important' }} />
        </Tooltip>
      }
      sx={{
        backgroundColor: eyebrow.color.background,
        color: eyebrow.color.color,
        fontWeight: 600,
        textTransform: 'uppercase',
        ...sx,
      }}
      {...rest}
    />
  );
};

export default ProductEyebrow;
